__turbopack_context__.v({
  "article": "_8tvS-G_article",
  "articles": "_8tvS-G_articles",
  "description": "_8tvS-G_description",
  "root": "_8tvS-G_root",
  "step": "_8tvS-G_step",
  "title": "_8tvS-G_title",
});
